import React from "react";
import { Button, Modal } from "@mui/material";

import { useTranslation } from "react-i18next";
import * as Styled from "../ModalConfiguracoesStyles";

type ModalEnableProps = {
  isOpen: boolean;
  onNo: () => void;
  onYes: () => Promise<void>;
};

const ModalEnable = ({ isOpen, onNo, onYes }: ModalEnableProps) => {
  const { t } = useTranslation();
  return (
    <Modal closeAfterTransition keepMounted open={isOpen} onClose={onNo}>
      <Styled.Box>
        <Styled.ModalTitle>
          {t("areYouSureYouWantToDeactivateThisDealer")}
        </Styled.ModalTitle>
        <Styled.ModalBody>{t("byDeactivatingTheDealer")}</Styled.ModalBody>
        <Styled.ContentActions>
          <Button color="error" variant="contained" onClick={onYes}>
            {t("yes")}
          </Button>
          <Button color="inherit" variant="outlined" onClick={onNo}>
            {t("no")}
          </Button>
        </Styled.ContentActions>
      </Styled.Box>
    </Modal>
  );
};

export default ModalEnable;
